/* Important Info component on the BreakdownAddEditForm
   telling users where to add new locations */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Scene.module.css";

const Info = () => {
  return (
    <div>
    <Row className="mb-3">
      <Col className="d-none d-md-block" md={1}></Col>     
      <Col xs={12} md={10} >
        <div className={`px-3 py-2 mt-2 ${styles.SubTitle6}`}>
          <p className={`${styles.Red} text-center`}>QUICK FIND POSTS INFO</p>
          <hr className={`mt-2 mb-0`}/>
          <p className={`pt-2`}><span className={`${styles.Red}`}>*</span> The Quick Find Posts page is designed to facilitate work in the Scenes Workspace
          by enabling you to quickly find relevent Posts.
          </p>
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Starred</span> and <span className={`${styles.Red}`}>Liked</span> tabs to display all your Starred and Liked Posts.
          </p> 
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Feed</span> tab to display all the Posts from Crew Members you are following
          so you stay on top of all work relevant to you.
          </p>  
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> Add Crew Members to your Feed by clicking 
          the <span className={`${styles.Red}`}>Follow</span> button on their Profile on the Profiles page.
          </p> 
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Posts by Department</span> section 
          displays the amount of Read and Unread Posts in each Department Category.
          </p> 
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> Click the <span className={`${styles.Red}`}>Requirements</span> tab 
             to find all your Department's Production Requirements. 
          </p> 
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> Click the <span className={`${styles.Red}`}>Workspace</span> tab to instantly find your 
             Department's latest work and to keep track of all previous work. 
          </p>
          <p className={`${styles.SmallInfo} pt-3`}> Requirements and Finals Posts are ordered by Scene Number, Workshop Posts by date.
          </p>   
         </div>
      </Col>
    </Row>
    </div>
  )
}

export default Info